import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import TripDetail from "@/pages/TripDetail";
import PublicTrip from "@/pages/PublicTrip";
import AuthCallback from "@/pages/AuthCallback";
import Upgrade from "@/pages/Upgrade";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PrintTrip from "@/pages/PrintTrip";
import ProtectedRoute from "@/components/ProtectedRoute";

function RootRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-500 font-mono-code text-sm">Loading…</div>;
  return user ? <Navigate to="/dashboard" replace/> : <Landing/>;
}

function AppRouter() {
  const location = useLocation();
  // Detect Emergent Google Auth session_id in URL fragment during render (prevents race)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback/>;
  }
  return (
    <Routes>
      <Route path="/" element={<RootRoute/>}/>
      <Route path="/auth/callback" element={<AuthCallback/>}/>
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard/></ProtectedRoute>}/>
      <Route path="/trips/:id" element={<ProtectedRoute><TripDetail/></ProtectedRoute>}/>
      <Route path="/trips/:id/print" element={<ProtectedRoute><PrintTrip/></ProtectedRoute>}/>
      <Route path="/upgrade" element={<ProtectedRoute><Upgrade/></ProtectedRoute>}/>
      <Route path="/payment/success" element={<PaymentSuccess/>}/>
      <Route path="/payment/cancel" element={<PaymentCancel/>}/>
      <Route path="/s/:token" element={<PublicTrip/>}/>
      <Route path="*" element={<Navigate to="/" replace/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter/>
        <Toaster richColors position="top-right"/>
      </BrowserRouter>
    </AuthProvider>
  );
}
